export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LkNotifications.vue?vue&type=template&id=122bbe38&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/components/LkNotifications.vue?vue&type=template&id=122bbe38&
// module id = 1589
// module chunks = 0